import React from 'react';
import { Typography } from '../../components';
import "./styles.css";

import logocfconnect from '../../assets/images/inloggen/logocfconnect.png';
import logocfacademy from '../../assets/images/inloggen/logocfacademy.png';
import logocfcommunity from '../../assets/images/inloggen/logocfcommunity.png';

import { Container, Introduction, SignUpCardWrapper } from './styled';

export default function SignUp(props) {

const SignUpCard = ({ title, title2, subtitle, img, alt, href }) => (
    <SignUpCardWrapper onClick={() => window.open(href, '_blank')}>
      <Typography type="h2" style={{ color: '#75391b' }}>{title}</Typography>
      <Typography type="h2" style={{ color: '#114d55' }}>{title2}</Typography>
      <Typography type="body">{subtitle}</Typography>
      <img src={img} alt={alt} />
    </SignUpCardWrapper>
  );

    return (
        <Container>
            <Introduction>
                <Typography type='h1' style={{ color: '#114d55', margin: '0 0 3vw 0' }}>
                    Nieuw account aanmaken
                </Typography>
                <Typography type='caps' style={{ color: '#B2522D' }}>
                    Klik op de online omgeving en meld je gratis aan.
                </Typography>
                <Typography type="body" style={{ color: '#B2522D' }}>
                    Heb je een code gekregen voor de online module van bijeenkomst 1, 2 en/of 3?<br />
                    Eenmaal ingelogd in jouw nieuwe account kun je deze code gebruiken voor toegang tot de modules.
                </Typography>
            </Introduction>

            <div
                style={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: '3vw',
                    flexWrap: 'wrap'
                }}
            >
                {/* CF Connect */}
                <SignUpCard
                    title="Aanmelden"
                    title2="Centering Feeding Connect"
                    subtitle="Voor ouders"
                    img={logocfconnect}
                    alt="Centering Feeding Connect"
                    href="https://kenniscentrumvoorouders.centeringfeeding.nl/checkout/gratis-nieuw"
                />

                {/* CF Academy */}
                <SignUpCard
                    title="Aanmelden"
                    title2="Centering Feeding Academy"
                    subtitle="Voor zorgprofessionals"
                    img={logocfacademy}
                    alt="Centering Feeding Academy"
                    href="https://kenniscentrumvoorzorgprofessionals.centeringfeeding.nl/checkout/early-bird-inschrijving-kenniscentrum-centering-feeding-voor-zorgprofessionals"
                />

                {/* CF Community */}
                <SignUpCard
                    title="Aanmelden"
                    title2="Centering Feeding Community"
                    subtitle="Voor begeleiders"
                    img={logocfcommunity}
                    alt="Centering Feeding Community"
                    href="https://centeringfeeding.com/routekaart-lactatiekundigen"
                />
            </div>
        </Container>
    );
}